import React, { useState } from "react";
import './Newsletter.css'


const Newsletter = () => {

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const validateEmail = (value) => {
    const cleanedValue = value.replace(/\s/g, ""); // remove all spaces
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!cleanedValue) {
      return "Email is required.";
    } else if (!emailRegex.test(cleanedValue)) {
      return "Enter a valid email address.";
    }

    return "";
  };

  const handleChange = (e) => {
    const cleanedValue = e.target.value.replace(/\s/g, ""); // no spaces
    setEmail(cleanedValue);
    if (error) {
      setError(validateEmail(cleanedValue)); // live error update
    }
  };

  const handleSubmit = (e) => {
    const validationError = validateEmail(email);
    if (validationError) {
      e.preventDefault();
      setError(validationError);
    }
  };
  return (
    <div className='newsletter-container'>
      <div className='newsletter-section'>
        <h1 className='newsletter-title'>
          Subscribe for latest update</h1>
        <form
          action="https://api.web3forms.com/submit"
          method="POST"
          noValidate
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="access_key" value="a854e710-e446-47b4-8f39-caa5c5ca9a94" />
          <input type="hidden" name="subject" value="New NewsLetter Mail From RiseFX Website" />

          <div className="newsletter-input-container">
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            className="newsletter-input"
            value={email}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === " ") e.preventDefault(); // block spaces from keyboard
            }}
            required
          />
          {error && <p className="newsletter-error">{error}</p>}
          </div>

          <button className="newsletter-subscribe">Subscribe</button>
        </form>
      </div>
    </div>
  );
}

export default Newsletter;
